/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTaskDependenciesQuery } from '../../models/get-project-task-dependencies-query';
import { GetProjectTaskDependenciesQueryResult } from '../../models/get-project-task-dependencies-query-result';

export interface ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Params {
      body?: GetProjectTaskDependenciesQuery
}

export function apiProjectTaskDependencyGetProjectTaskDependenciesPost(http: HttpClient, rootUrl: string, params?: ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskDependenciesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskDependencyGetProjectTaskDependenciesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTaskDependenciesQueryResult>;
    })
  );
}

apiProjectTaskDependencyGetProjectTaskDependenciesPost.PATH = '/api/ProjectTaskDependency/GetProjectTaskDependencies';
